import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onClick", "onKeydown", "aria-label"]
const _hoisted_2 = { class: "menu-list-item-label" }

import { $session } from "framework"
import { nextTick, onBeforeUpdate, computed, reactive, ref, watch } from "vue"
import { useSiteStore } from "@/store/site"
import { useAuthStore } from "@/store/auth"
import router from "@/router"

interface UserInfo {
  NAME: string;
  USER_ID: string;
  USER_NO: string;
  USER_ROLES: {
    dotSaasVision: string;
    dotSaasClass: string;
    dotSaasSupport: string;
  };
}

interface State {
  userInfo: UserInfo;
}

interface Store {
  param: {
    a: string;
    r: string;
    u: string;
  } | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginBtn',
  setup(__props) {

const siteStore: Store = useSiteStore()
const authStore = useAuthStore()

const isLogin = computed(() => authStore.isAuthenticated)

const state = reactive<State>({
  userInfo: {
    NAME: "",
    USER_ID: "",
    USER_NO: "",
    USER_ROLES: {
      dotSaasVision: "",
      dotSaasClass: "",
      dotSaasSupport: "",
    },
  },
});
const initUserInfo = () => {
  const userName = $session.getUserInfo()?.NAME?.slice(0, 1) || "U";
  const userId = $session.getUserInfo()?.USER_ID;
  const userNo = $session.getUserNo();
  const userRole = $session.getUserRoles("dot-saas-support");

  state.userInfo.NAME = userName;
  state.userInfo.USER_NO = userNo;
  state.userInfo.USER_ID = userId;
  state.userInfo.USER_ROLES.dotSaasSupport = userRole;
};

if (isLogin.value) {
  initUserInfo();
}

watch(isLogin, (val) => {
  if (val) {
    initUserInfo();
  } else {
    state.userInfo = {
      NAME: "",
      USER_ID: "",
      USER_NO: "",
      USER_ROLES: {
        dotSaasVision: "",
        dotSaasClass: "",
        dotSaasSupport: "",
      },
    };
  }
});

const menu = ref(false)
const btnList = [
  {
    key: "profile",
    label: "프로필"
  },
  {
    key: "logout",
    label: "로그아웃"
  }
]
const btnRefs = ref<HTMLElement[]>([])

watch(menu, async (isOpen) => {
  if (!isOpen) return

  await nextTick()
  requestAnimationFrame(() => {
    const el = btnRefs.value[0]
    if (el instanceof HTMLElement) {
      el.focus()
    }
  })
})

const login = () => {
  router.push("/login")
}

const profile = () => {
  const sso = $session.getSsoDomain();
  const s = $session.getSiteNo();
  const c = $session.getCompNo();
  const a = siteStore.param?.a;
  const cb = window.location.origin;

  const url = `${sso}/basic?s=${s}&c=${c}&a=${a}&cb=${cb}/login-callback`;

  window.open(url)
}

const logOut = async () => {
  await $session.signOut();

  authStore.setAuthenticated(false);

  state.userInfo = {
    NAME: "",
    USER_ID: "",
    USER_NO: "",
    USER_ROLES: {
      dotSaasVision: "",
      dotSaasClass: "",
      dotSaasSupport: "",
    },
  };
};

const onBtnItemKeydown = (
    event: KeyboardEvent,
    index: number,
    code: string
) => {
  const key = event.key

  console.log("on btn item keydown evet", index, code)

  if (key === "ArrowDown" || key === "ArrowUp") {
    event.preventDefault()

    const lastIndex = btnList.length - 1
    let nextIndex = index

    if (key === "ArrowDown") {
      nextIndex = index === lastIndex ? 0 : index + 1
    }
    else if (key === "ArrowUp") {
      nextIndex = index === 0 ? lastIndex : index - 1
    }
    requestAnimationFrame(() => {
      const el = btnRefs.value[nextIndex]
      if (el instanceof HTMLElement) {
        el.focus()
      }
    })
    return
  }

  if (key === "Enter" || key === " " || key === "Spacebar") {
    event.preventDefault()
    event.stopPropagation()
    onClickHandler(code)
  }
}

const onClickHandler = (key: string) => {
  switch (key) {
    case "profile":
      profile()
      break
    case "logout":
      logOut()
      break
  }
}

onBeforeUpdate(() => {
  btnRefs.value = []
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!isLogin.value)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          class: "login-text",
          variant: "text",
          ripple: false,
          onClick: login
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("로그인")), 1)
          ]),
          _: 1
        }))
      : (isLogin.value)
        ? (_openBlock(), _createBlock(_component_v_menu, {
            key: 1,
            modelValue: menu.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((menu).value = $event)),
            location: "bottom end",
            transition: "none",
            "close-on-content-click": true
          }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _mergeProps(props, {
                icon: "",
                class: "btn-user-name",
                "aria-label": `${_unref($session).getUserInfo()?.NAME} ${_ctx.$t('프로필')}`,
                ripple: false
              }), {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(state.userInfo.NAME), 1)
                ]),
                _: 2
              }, 1040, ["aria-label"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_sheet, {
                class: "menu-list",
                role: "menu"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(btnList, (btn, index) => {
                    return _createElementVNode("div", {
                      key: btn.key,
                      ref_for: true,
                      ref_key: "btnRefs",
                      ref: btnRefs,
                      class: "menu-list-item",
                      onClick: ($event: any) => (onClickHandler(btn.key)),
                      onKeydown: ($event: any) => (onBtnItemKeydown($event, index, btn.key)),
                      tabindex: "1",
                      "aria-label": _ctx.$t(btn.label),
                      role: "menuitem",
                      "aria-roledescription": "button"
                    }, [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t(btn.label)), 1)
                    ], 40, _hoisted_1)
                  }), 64))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
  ]))
}
}

})